import { BaseResponse } from './base.response';
import { Pricelist } from '../models';

export class PricelistResponse extends BaseResponse {

  public pricelists: Pricelist[];

}
